import React from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import GridViewIcon from '@mui/icons-material/GridView';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItemButton, ListItemIcon, Modal, TextField, Typography } from '@mui/material';
import BookmarksContext from '../context/BookmarkContext';
import Popover from '@mui/material/Popover';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

function MyCustomDialog({ open, onClose, targetBlock, handleAddLink }) {

    const defaultComment = targetBlock?.f12 || "";
    
    const [comment, setComment] = React.useState(defaultComment)

    const handleAddLinkBlock = ()=>{

        handleAddLink(comment,targetBlock)
        onClose()
    }

    return (
      <Dialog open={open} onClose={() => onClose()}>
        <DialogTitle>Add comment to block link</DialogTitle>
        <DialogContent>
          <TextField value={comment} label="Add comment" onChange={(e)=>setComment(e.target.value)}/>
        </DialogContent>
        <DialogActions>
            <Button onClick={ handleAddLinkBlock}>Add Link</Button>
            <Button onClick={() => onClose()}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

function BlockLinkModal({selectedBlock,handleClose, modalOpen, handleAddLink, linkedBlocks}) {

    const { bookmarks } = React.useContext(BookmarksContext)

    const [dialogOpen, setDialogOpen] = React.useState(false);

    const [targetBlock, setTargetBlock] = React.useState(null)

    const handleDialogOpen = (bookmark) => {
        setTargetBlock(bookmark)
        setDialogOpen(true);
      };
    
    const handleDialogClose = () => {
        setDialogOpen(false);
        handleClose()
      };


  return (
    <div>
        <Modal
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >
            <Box sx={{ ...style, width: 400 }}>

            <Typography id="spring-modal-title" variant="h6" component="h2">
             Bookmarks
            </Typography>
            
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper', maxHeight:500 }}>
                {bookmarks
                    ?.filter(
                        (bookmark) => bookmark.f14 !== selectedBlock?.f14 && !linkedBlocks.some((linkedBlock) => linkedBlock.block_id === bookmark?.f14
                          )
                      )
                    .map((bookmark, index) => (
                    <ListItem onClick={()=>handleDialogOpen(bookmark)} key={index}>
                        <ListItemButton>
                            <ListItemIcon>
                                <GridViewIcon/>
                            </ListItemIcon>
                            <ListItemText primary={`[${bookmark?.f14}] ${bookmark?.f12} `|| 'Unnamed Bookmark'} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <div style={{display:'flex',alignItems:'center', justifyContent:'end'}}>
                
                <Button onClick={handleClose}>
                    Cancel
                </Button>
            </div>
            </Box>
            
        </Modal>
        {dialogOpen && <MyCustomDialog open={dialogOpen} onClose={handleDialogClose} targetBlock={targetBlock} handleAddLink={handleAddLink}/>}
        </div>
  )
}

export default BlockLinkModal